// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3bu2g","header":"Messages_header__2sWB5"};